import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from "./lang/index"
import 'element-ui/lib/theme-chalk/index.css'
import elementConfig from "@/utils/element-config.js"

Vue.use(elementConfig);

Vue.config.productionTip = false

new Vue({
    router,
    i18n,
    render: h => h(App),
}).$mount('#app')